const TALKJS_PARTNER_ROLE = 'MEDIA_PARTNER';
const TALKJS_ADMIN_ROLE = 'ADMIN';
const TALK_JS_APP_ID = 't682nAU1';
const TALK_JS_ADMIN_ID = 'CLEAREM_ADMIN';

function talkJsUser(id, name,email, role, welcomeMessage = '') {
    // TODO-NT photoUrl?
    return new window.Talk.User({ id, name, email, role, ...(welcomeMessage ? {welcomeMessage} : {}) });
};

export async function initializeTalkJsPartner(user, eventId) {
    const Talk = window.Talk;
    await Talk.ready;
    const me = talkJsUser(user.id, user.fullName, user.email, TALKJS_PARTNER_ROLE);
    const session = new Talk.Session({
        appId: TALK_JS_APP_ID,
        me: me
    });
    const admin = talkJsUser(`${TALK_JS_ADMIN_ID}_${eventId}`, "Clear'em Support", 'support@clearem.com', TALKJS_ADMIN_ROLE, 'Hey, how can I help?');
    const conversation = session.getOrCreateConversation(Talk.oneOnOneId(me, admin));
    conversation.setParticipant(me);
    conversation.setParticipant(admin);
    const popup = session.createPopup(conversation, {launcher: 'never'});
    popup.mount({ show: false });
    return popup;
}

export async function initializeTalkJsAdmin(eventId) {
    const Talk = window.Talk;
    await Talk.ready;
    const me = talkJsUser(`${TALK_JS_ADMIN_ID}_${eventId}`, "Clear'em Support", 'support@clearem.com', TALKJS_ADMIN_ROLE, 'Hey, how can I help?');
    const session = new Talk.Session({
        appId: TALK_JS_APP_ID,
        me: me
    });
    const inbox = session.createInbox();
    inbox.mount(document.getElementById("ckp-js-admin-chat"));
    return inbox;
}



// WEBPACK FOOTER //
// ./src/services/talk.chat.js